import { useQuery } from '@tanstack/react-query'

import { GetCorretagens } from '@/features/proposta/services/get-corretagens.service'
import { propostaKeys } from '@/features/proposta/utils'

export const useCorretagens = (simulacoesIds: string[]) => {
  return useQuery({
    queryKey: propostaKeys.listaCorretagens(simulacoesIds),
    queryFn: async () => new GetCorretagens().execute(simulacoesIds).then((res) => res.data),
    staleTime: 30 * 60 * 1000,
  })
}
